import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatProgressBarModule} from '@angular/material/progress-bar';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core'
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { HttpClientModule, HttpClient } from '@angular/common/http'
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { AnswerComponent } from './answer/answer.component';
import { Service } from './service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AdvisorsComponent } from './advisors/advisors.component';
import { QuestionComponent } from './advisors/question/question.component';
import { HomeComponent } from './advisors/home/home.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';


export function HttpsLoaderFactory(http: HttpClient){
  return new TranslateHttpLoader(http);
}


@NgModule({
  declarations: [
    AppComponent,
    QuestionComponent,
    HomeComponent,
    AnswerComponent,
    AdvisorsComponent,
    PageNotFoundComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    FormsModule,
    MatProgressBarModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpsLoaderFactory,
        deps: [HttpClient]
      }
    }),
    



  ],
  providers: [Service],
  bootstrap: [AppComponent]
})
export class AppModule { }
